import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { take } from 'rxjs';
import { ToLocaleFormat } from '../../basic/pipes/to-locale-format.pipe';
import { ResumeService } from '../../core/resume/resume.service';
import { UploadResumeComponent } from '../../domain/resume/upload-resume/upload-resume.component';
import { InterviewSidebarComponent } from '../home/interview-sidebar/interview-sidebar.component';
import { TruncatePipe } from './../../basic/pipes/truncate.pipe';

@Component({
  selector: 'app-interview-resume',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,

    NzIconModule,
    NzInputModule,
    NzButtonModule,
    NzTableModule,
    NzPopoverModule,
    NzUploadModule,
    NzModalModule,
    NzPopconfirmModule,

    TruncatePipe,
    ToLocaleFormat,

    MatTooltip,

    InterviewSidebarComponent,

    UploadResumeComponent,
  ],
  templateUrl: './interview-resume.component.html',
  styleUrl: './interview-resume.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InterviewResumeComponent {
  html = '';

  isNewResumeVisible = false;

  resumeList = toSignal(this.resumeService.resumeList$(), { initialValue: [] });

  constructor(
    private resumeService: ResumeService,
    private msg: NzMessageService
  ) {}

  ngOnDestroy(): void {}

  onNewResumeClick() {
    this.isNewResumeVisible = true;
  }

  onDeleteResumeClick(i: number) {
    this.resumeService.deleteResumeList$([this.resumeList()[i]]).pipe(take(1)).subscribe();
  }

  onDownloadResumeClick(i: number) {
    const resume = this.resumeList()[i];
    const url = resume.subData.pdfUrl;

    console.log('---- resume: url:', url);
    window.open(url, '_blank');
  }
}
